import React, { useState, useEffect, useContext } from "react";
import { v4 } from "uuid";
import Turno from "./Turno";
import AlertaContext from "../../../../Context/Alerta/AlertaContext";

// MATERIAL
import { makeStyles } from "@mui/styles";
import { Box, IconButton, FormControl, Typography } from "@mui/material";
import {
  AddCircle,
  ExitToApp,
  // CloudDownload,
} from "@mui/icons-material";
const useStyles = makeStyles((theme) => ({
  inputPadding: {
    padding: theme.spacing(0.25),
    margin: theme.spacing(0),
    fontSize: ".9rem",
  },

  form25PC: {
    flexGrow: 1,

    width: "23%",

    [theme.breakpoints.down("md")]: {
      padding: "0",
      margin: "2px",
      width: "45%",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0",
      margin: "2px",
      width: "70%",
    },
  },
  formAllW: {
    flexGrow: 1,
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    width: "95%",

    [theme.breakpoints.down("md")]: {
      padding: "0",
      margin: "2px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0",
      margin: "2px",
    },
  },
}));
const Turnos = (props) => {
  const clases = useStyles();
  const { item, setitem, error, estadoRequest, ubicacionesData } = props;
  const [cargando, setcargando] = useState(true);
  const { mostrarAlerta } = useContext(AlertaContext);
  console.log({ item });

  useEffect(() => {
    const resTurnos = item.horarios.map((itemTurno) => {
      if (
        itemTurno.fechas_milisegundos &&
        itemTurno.fechas_iso &&
        itemTurno.id
      ) {
        return {
          ...itemTurno,
          fechas_iso:
            itemTurno.fechas_iso.length > 0 && itemTurno.salida
              ? []
              : itemTurno.fechas_iso,
        };
      } else {
        return {
          ...itemTurno,
          fechas_milisegundos: [],
          fechas_iso: [],
          id: v4(),
        };
      }
    });
    setitem({
      ...item,
      horarios: resTurnos,
    });
    setcargando(false);
    // eslint-disable-next-line
  }, []);
  if (cargando) {
    return null;
  }
  return (
    <>
      <FormControl className={clases.formAllW}>
        <Box display="flex" alignItems="center">
          <Typography
            variant="subtitle1"
            color={error.horarios ? "error" : "primary"}
          >
            Turnos:
          </Typography>
          <IconButton
            color="secondary"
            aria-label=""
            size="small"
            // disabled={item.horarios.length === 1}
            onClick={async () => {
              const existeVacio = item.horarios.some((item) => {
                console.log(
                  item.ubicacion,
                  item.fechas_milisegundos,
                  item.fechas_iso
                );
                return (
                  item.ubicacion === "" ||
                  item.fechas_milisegundos.length === 0 ||
                  item.fechas_iso.length === 0
                );
              });

              if (existeVacio) {
                return mostrarAlerta("Complete todos los campos.", "error");
              }
              setitem({
                ...item,
                horarios: [
                  ...item.horarios,
                  {
                    id_horario_ubicacion: 0,
                    ubicacion: "",
                    puesto: "",

                    fechas_milisegundos: [],
                    fechas_iso: [],
                    id: v4(),
                  },
                ],
              });
            }}
          >
            <AddCircle fontSize="small" />
          </IconButton>
        </Box>
      </FormControl>
      {item.horarios.map((turno, index) => {
        return (
          <Turno
            ubicacionesData={ubicacionesData}
            estadoRequest={estadoRequest}
            key={turno.id}
            index={index}
            turno={turno}
            item={item}
            setitem={setitem}
          />
        );
      })}
    </>
  );
};

export default Turnos;
